import React from "react";
import { motion } from "framer-motion";
import { Download, ArrowRight, Sparkles } from "lucide-react";
import { useSite } from "@/context/SiteData";

const PDF_URL = `${process.env.REACT_APP_BACKEND_URL}/api/calendar.pdf`;

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = ({ onBook }) => {
  const { settings: s } = useSite();
  const scrollToCorsi = () =>
    document.getElementById("corsi")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative overflow-hidden pt-20 pb-12 sm:pt-28 sm:pb-16">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="absolute -top-40 -right-32 w-[36rem] h-[36rem] rounded-full bg-[#2FA84F]/8 blur-3xl pointer-events-none" />
      <div className="absolute -top-24 -left-40 w-[32rem] h-[32rem] rounded-full bg-[#EA6A0A]/8 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          {...fade(0)}
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-gray-200 text-[#EA6A0A] text-xs sm:text-sm font-600 shadow-sm mb-8"
          data-testid="hero-badge"
        >
          <Sparkles size={14} className="text-[#EA6A0A]" />
          {s.hero_badge || "3ª Sessione 2026 · Formazione Salute e Sicurezza sul Lavoro"}
        </motion.div>

        <motion.h1
          {...fade(0.08)}
          className="font-display font-800 tracking-tighter text-[#EA6A0A] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-4xl mx-auto"
          data-testid="hero-title"
        >
          {s.hero_title || "Calendario Corsi Salute e Sicurezza 2026"}
        </motion.h1>

        <motion.p
          {...fade(0.16)}
          className="mt-6 text-base sm:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed"
        >
          {s.hero_subtitle || "Tutti i corsi di formazione obbligatoria in un unico posto. Consulta date, orari, durata e prezzi, filtra per categoria e prenota il tuo corso in pochi click."}
        </motion.p>

        <motion.div
          {...fade(0.24)}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3"
        >
          <button
            data-testid="hero-book-btn"
            onClick={onBook}
            className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#EA6A0A] text-white font-600 shadow-[0_8px_24px_-4px_rgba(234,106,10,0.4)] hover:bg-[#C8590A] hover:scale-[1.03] transition-all w-full sm:w-auto justify-center"
          >
            {s.cta_book || "Prenota un corso"}
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </button>
          <a
            data-testid="hero-download-btn"
            href={PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white text-[#EA6A0A] font-600 border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-all w-full sm:w-auto justify-center"
          >
            <Download size={18} />
            {s.cta_download || "Scarica il calendario"}
          </a>
        </motion.div>
      </div>
    </section>
  );
};
